import { format } from 'date-fns';
import { enUS, pt, fr, es, ar } from 'date-fns/locale';
import { toZonedTime } from 'date-fns-tz';

interface UserPreferences {
  language?: string;
  timezone?: string;
  date_format?: string;
  time_format?: string;
}

const localeMap = {
  en: enUS,
  pt: pt,
  fr: fr,
  es: es,
  ar: ar,
  sw: enUS, // Swahili uses English locale as fallback
};

export const formatDate = (
  date: Date | string,
  preferences?: UserPreferences
): string => {
  let dateObj = typeof date === 'string' ? new Date(date) : date;
  
  // Apply timezone if specified
  if (preferences?.timezone) {
    dateObj = toZonedTime(dateObj, preferences.timezone);
  }
  
  const dateFormat = preferences?.date_format || 'DD/MM/YYYY';
  const locale = localeMap[preferences?.language as keyof typeof localeMap] || enUS;

  let formatString = 'dd/MM/yyyy';
  if (dateFormat === 'MM/DD/YYYY') {
    formatString = 'MM/dd/yyyy';
  } else if (dateFormat === 'YYYY-MM-DD') {
    formatString = 'yyyy-MM-dd';
  }

  return format(dateObj, formatString, { locale });
};

export const formatTime = (
  time: Date | string,
  preferences?: UserPreferences
): string => {
  let timeObj = typeof time === 'string' ? new Date(time) : time;
  
  // Apply timezone if specified
  if (preferences?.timezone) {
    timeObj = toZonedTime(timeObj, preferences.timezone);
  }
  
  const timeFormat = preferences?.time_format || '24h';
  const locale = localeMap[preferences?.language as keyof typeof localeMap] || enUS;

  const formatString = timeFormat === '12h' ? 'h:mm a' : 'HH:mm';

  return format(timeObj, formatString, { locale });
};

export const formatDateTime = (
  dateTime: Date | string,
  preferences?: UserPreferences
): string => {
  return `${formatDate(dateTime, preferences)} ${formatTime(dateTime, preferences)}`;
};
